// ** I18n Imports
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import viTranslation from './vi.json'
import enTranslation from './en.json'

const resources = {
  vi: {
    translation: viTranslation
  },
  en: {
    translation: enTranslation
  }
}

const lag = typeof window !== 'undefined' ? window.localStorage.getItem('i18nextLng') : null

i18n
  // Enable automatic language detection
  .use(LanguageDetector)
  // Enables the hook initialization module
  .use(initReactI18next)
  .init({
    resources,
    lng: lag ? lag : 'vi',
    fallbackLng: 'vi',
    debug: false,
    keySeparator: false,
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    }
  })

export default i18n
